<template>
  <div class="base_info_window">
    <div class="mark_content company_mark_content">
      <div class="mark_content_top">
        <div class="company_name">{{allData.company_name}}</div>
        <div class="company_info">
          <span class="score">评分<span class="value">{{allData.score}}</span></span>
          <span class="sort">排名<span class="value">{{allData.sort}}</span></span>
        </div>
      </div>
      <div class="mark_content_bottom">
        <div class="suggest" v-for="(item, index) in allData.suggest" :key="index">{{item}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "base_info_window",
    props: {

    },
    data() {
      return {
        allData: {}
      }
    },
    computed: {
    },
    components: {},
    created() {
    },
    mounted() {

    },
    methods: {}
  }
</script>

<style lang="less" scoped>
.base_info_window{

  .mark_content{
    background: #ffffff;
    padding: 5px 15px;
    border-radius: 5px;
    text-align: center;
    line-height: 1;
    /*border: 1px solid rgba(0,0,0,0.2);*/
    box-shadow: 0 0 5px rgba(0,0,0,0.5);
  }

  .company_mark_content{
    background: rgba(0,0,0,0.8);
    text-align: left;
    .mark_content_top{
      color: #ffffff;
      border-bottom: 1px dashed #9ea0ab;
      padding-bottom: 5px;
      margin-bottom: 5px;
      padding-top: 5px;
      .company_name{

      }
      .company_info{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .value{
          color: #42bffe;
        }
        .score{

        }
        .sort{

        }
      }
    }
    .mark_content_bottom{
      color: #42bffe;
      line-height: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/main_content/map/baseMap/base_info_window.vue